import { Handle, Position, getOutgoers } from "reactflow";
import { getNodeDetails, nodeWidth } from "../flowSettings";
import { useMemo } from "react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import EventNode from "./event/EventNode";
import ActionNode from "./ActionNode";
import ContactNumber from "../components/ContactNumber";
import LinkerOverlay from "../components/LinkerOverlay";
import { Stack } from "@mantine/core";
import NodePlus from "./NodePlus";
import { getNodeHeight } from "../layouter";

const BaseNode = ({ data, id, xPos, yPos }) => {

  const linking = useFlowStore((s) => s.linking);

  const nodeDetail = useMemo(
    () => getNodeDetails(data.actionType),
    [data.actionType]
  );

  const nodeComponent = useMemo(() => {
    if (data?.actionType === "event") {
      return (
        <EventNode
          data={data}
          id={id}
          nodeDetail={nodeDetail}
          xPos={xPos}
          yPos={yPos}
        />
      );
    }
    return (
      <ActionNode
        data={data}
        xPos={xPos}
        yPos={yPos}
        id={id}
        nodeDetail={nodeDetail}
      />
    );
  }, [data, id, nodeDetail, xPos, yPos]);

  return (
    <Stack w={200} pos={"relative"} h={getNodeHeight()} align="center">
      <Handle
        type="target"
        position={Position.Left}
        style={{ visibility: "hidden", left: data?.actionType !== "event" ? -32 : undefined }}
      />

      {/* {outgoers.length > 0 && !linking && (
        <NodeBrancherCreator
          source={id}
          sourceX={xPos}
          sourceY={yPos}
          shouldBeEvent={data?.actionType !== "event"}
          error={data?.error}
        />
      )} */}

      <ContactNumber number={data?.number_contacts || 0} />

      <Handle
        type="source"
        position={Position.Right}
        style={{ visibility: "hidden", right: data?.actionType !== "event" ? -32 : undefined  }}
      />

      {nodeComponent}
    </Stack>
  );
};

export default BaseNode;
